import { Divider, Grid } from "@material-ui/core";
import ShimmerBox from "components/shared/shimmer-box";
import { Fragment } from "react";

import style from "./SectionsShimmer.module.scss";
import roundedButtonStyle from "styles/buttons/rounded-button.module.scss";

const SectionsShimmer = () => {
  return (
    <Fragment>
      <Grid item xs={12}>
        <ShimmerBox width="30%" height="25px" classes="mb-1" />
        <ShimmerBox width="95%" height="20px" classes="mb-1" />
        <ShimmerBox width="95%" height="20px" classes="mb-1" />
        <ShimmerBox width="95%" height="20px" classes="mb-1" />
        <ShimmerBox width="95%" height="20px" />
      </Grid>
      <Grid item xs={12}>
        <Divider light />
      </Grid>
      <Grid item xs={12}>
        <ShimmerBox width="30%" height="25px" classes="mb-1" />
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <ShimmerBox width="50px" height="50px" classes={style.item} />
          <ShimmerBox width="50px" height="50px" classes={style.item} />
          <ShimmerBox width="50px" height="50px" classes={style.item} />
          <ShimmerBox width="50px" height="50px" classes={style.item} />
          <ShimmerBox width="50px" height="50px" classes={style.item} />
        </div>
      </Grid>
      <Grid item xs={12}>
        <Divider light />
      </Grid>
      <Grid item xs={12}>
        <ShimmerBox
          height="45px"
          width="100%"
          classes={`${roundedButtonStyle.root} mb-1`}
        />
        <ShimmerBox
          height="45px"
          width="100%"
          classes={`${roundedButtonStyle.root} mb-1`}
        />
        <ShimmerBox
          height="45px"
          width="100%"
          classes={`${roundedButtonStyle.root}`}
        />
      </Grid>
    </Fragment>
  );
};

export default SectionsShimmer;
